import { CategoriaEnum } from '@acme/auth'
import { Subscription } from '@cel_cash/core/types'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import RetryImage from 'assets/retry.png'
import { ContentGuide } from 'global/guides/ContentGuide'
import { useAuth } from 'hooks'
import { RefreshCwIcon } from 'lucide-react'
import { useState } from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import {
    assinaturas,
    Cliente,
    clientes,
    PlanoFixo,
    planos as planosApi,
} from 'service/api'
import { NotFound } from 'templates/NotFound'

export default function PlanosPage() {
    const { decoded } = useAuth()
    const [retryDelay, setRetryDelay] = useState(1000)

    const {
        data: assinatura,
        isLoading: isLoadingAssinatura,
        isFetched,
    } = assinaturas.minhaAssinatura.useFetch({
        enabled: true,
        refetchOnWindowFocus: false,
    })

    const { data: cliente = {} as Cliente } = clientes.useFetchById(
        decoded?.cliente,
    )
    const { data: PlanoDiferenciado } = planosApi.useFetchById('diferenciado')

    const {
        data: planos,
        failureCount,
        refetch,
        isLoading: isLoadingPlanos,
    } = planosApi.useFetch({
        enabled: true,
        retryDelay(failureCount) {
            return failureCount * retryDelay
        },
        refetchOnWindowFocus: false,
    })

    const handleClick = () => {
        setRetryDelay(state => state * 1.5)
        refetch()
    }

    if (
        ![CategoriaEnum.Cliente, CategoriaEnum.Avaliacao].includes(
            decoded?.categoria,
        )
    )
        return <NotFound />

    if (failureCount >= 4) {
        return (
            <ContentGuide>
                <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    height="100%"
                    flexDirection="column"
                    gap={2}
                >
                    <img
                        src={RetryImage}
                        alt="Erro ao carregar planos"
                        style={{ maxWidth: 180 }}
                    />
                    <Typography variant="h6" mt={-4}>
                        Ocorreu um erro ao buscar o recurso solicitado
                    </Typography>

                    <Button
                        variant="outlined"
                        onClick={handleClick}
                        sx={{
                            mb: 10,
                        }}
                        startIcon={<RefreshCwIcon />}
                    >
                        Tentar novamente
                    </Button>
                </Box>
            </ContentGuide>
        )
    }

    return (
        <Outlet
            context={{
                assinatura,
                planos,
                cliente,
                PlanoDiferenciado,
                isLoading: isLoadingAssinatura || isLoadingPlanos,
            }}
        />
    )
}

export const usePlanosContext = () => {
    return useOutletContext<{
        assinatura?: Subscription
        planos?: PlanoFixo[]
        cliente?: Cliente
        PlanoDiferenciado?: Cliente['PlanoDiferenciado'] | null
        isLoading: boolean
    }>()
}
